<div class="card collapsible-card"
     [ngClass]="overrideStyleClass">
    <div class="header card-header gap-2"
         [ngClass]="{ collapsible: isCollapsible, collapsed: collapsed }"
         (click)="toggle()"
         data-test="collapsible-card-header">
        @if (handleId) {
            <i class="fal fa-grip-dots-vertical pe-1 gripper"
               [attr.id]="handleId"></i>
        }
        @if (iconClass) {
            <i [ngClass]="iconClass"
               class="header-icon flex-shrink-0 show-icon-on-print"
               [adaptTooltip]="iconTooltip"></i>
        }
        <h4 class="m-0 d-flex align-items-baseline me-auto">
            @if (linkObject) {
                <a class="me-1"
                   [routerLink]="linkObject.path"
                   [queryParams]="linkObject.queryParams"> {{ name }}<i class="fal fa-angle-right ms-2"></i> </a>
            } @else {
                <span class="me-1">{{ name }}</span>
            }
            @if (info) {
                <i class="ms-1 fal fa-circle-info"
                   [adaptTooltip]="info"></i>
            }

            <ng-content select="[adapt-collapsible-header-action]"></ng-content>
        </h4>

        <ng-content select="[adapt-collapsible-header-action-right]"></ng-content>
        @if (isCollapsible && isExpandable) {
            <i class="fas {{ collapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}"></i>
        }
    </div>
    @if (isExpandable) {
        <div [collapse]="collapsed"
             (collapsed)="animationCompleted($event)"
             (expanded)="animationCompleted($event)"
             [isAnimated]="true">
            <div class="card-body element-body">
                @if (useScrollView) {
                    <dx-scroll-view [scrollByContent]="true"
                                    direction="horizontal">
                        <div class="body">
                            <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
                        </div>
                    </dx-scroll-view>
                } @else {
                    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
                }
            </div>
        </div>
    }
</div>

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
